import React from "react";
import './halloween.css';

function boxShadow(grid, colors) {
  const shadows = [];
  for (let y = 0; y < grid.length; y++) {
    for (let x = 0; x < grid[y].length; x++) {
      const c = grid[y][x];
      if (colors[c]) {
        shadows.push(`${x}px ${y}px 0 0 ${colors[c]}`);
      }
    }
  }
  return shadows.join(',');
}

const pumpkinGrid = [
  '......GG......',
  '.....GGGG.....',
  '...OOOOOOOO...',
  '..OOOOOOOOOO..',
  '.OOOOOOOOOOOO.',
  '.OOOYYOOYYOOO.',
  '.OOOYYOOYYOOO.',
  '.OOOOOOOOOOOO.',
  '.OOYOOYY' + 'OOYOO.',
  '.OOOYYYYYYOOO.',
  '..OOOOOOOOOO..',
  '...OOOOOOOO...',
  '.....OOOO.....',
];

const pumpkinColors = {
  'G': '#1a8a1a',
  'O': '#e86a17',
  'Y': '#f5c518',
};

const batGrid = [
  'P...P...P',
  'PP.PPP.PP',
  'PPPPPPPPP',
  '.PPPPPPP.',
  '..PP.PP..',
  '...P.P...',
];

const batColors = {
  'P': '#7b2fbe',
};

const ghostGrid = [
  '..PPP..',
  '.PPPPP.',
  '.PWPWP.',
  '.PPPPP.',
  'PPPPPPP',
  'P.PPP.P',
  '.P...P.',
];

const ghostColors = {
  'P': '#c8a0e8',
  'W': '#ffffff',
};

export const Halloween = () => {
  const pumpkinShadow = boxShadow(pumpkinGrid, pumpkinColors);
  const batShadow = boxShadow(batGrid, batColors);
  const ghostShadow = boxShadow(ghostGrid, ghostColors);

  return (
    <div className="halloween">
      <div className="pixel-art-container">
        <div
          className="pixel-sprite"
          style={{
            boxShadow: batShadow,
            left: '10px',
            top: '5px',
            transform: 'scale(8)',
          }}
        />
        <div
          className="pixel-sprite"
          style={{
            boxShadow: pumpkinShadow,
            left: '94px',
            top: '30px',
            transform: 'scale(8)',
          }}
        />
        <div
          className="pixel-sprite"
          style={{
            boxShadow: ghostShadow,
            left: '224px',
            top: '5px',
            transform: 'scale(8)',
          }}
        />
      </div>

      <div className="riddles">
        <div className="riddle-card">
          <p>The beginning stands alone</p>
        </div>
        <div className="riddle-card">
          <p>One reaches for the heavens, the other for the earth; together they mark the middle</p>
        </div>
        <div className="riddle-card">
          <p>The end belongs to the creature that never seems to run out chances</p>
        </div>
      </div>
    </div>
  );
};
